import { render, staticRenderFns } from "./PricingArea.vue?vue&type=template&id=2dc8246e&"
import script from "./PricingArea.vue?vue&type=script&lang=js&"
export * from "./PricingArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports